// extracted by mini-css-extract-plugin
export default {"errorPageContainer":"src-modules-error-page-style__errorPageContainer_4VClS"};